export const SearchTypeMetadata = 3 as const;
export type TSearchTypeMetadata = typeof SearchTypeMetadata;

/** elementSubType1 */
export enum MetadataType {
	MATCH_ALL_WHOLE_WORDS = 0,
	MATCH_EXACTLY = 1,
	MATCH_ANY_WHOLE_WORDS = 2,
	EXCLUDE = 3,
	MATCH_ALL_WILD_CARDS = 4,
	MATCH_ANY_WILD_CARDS = 5,
	MATCH_ANY_RANGE = 6,
	MATCH_VALUE_IS_EMPTY = 11,
	MATCH_VALUE_IS_NOT_EMPTY = 12,
	// Removed per https://jira.netx.net/browse/DAM-8229
	// Possibly related to attributes of type heirarchical?
	// {label: "Options [OPTS]", val: 7}
}

export const MetadataNoValueTypes = [
	MetadataType.MATCH_VALUE_IS_NOT_EMPTY,
	MetadataType.MATCH_VALUE_IS_EMPTY,
] as const;

export const MetadataSingleValueTypes = [
	MetadataType.EXCLUDE,
	MetadataType.MATCH_ALL_WHOLE_WORDS,
	MetadataType.MATCH_ALL_WILD_CARDS,
	MetadataType.MATCH_ANY_WHOLE_WORDS,
	MetadataType.MATCH_ANY_WILD_CARDS,
	MetadataType.MATCH_EXACTLY,
] as const;
